/**
 * @generated SignedSource<<9cfef5367442154911bc07e51279d6d0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Storecast_storecastScreen$data = {
  readonly dashboard: {
    readonly id: string;
    readonly name: string;
    readonly widgets: ReadonlyArray<{
      readonly __typename: string;
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"AllWidgets_widget" | "useWidgetToPos_widget">;
    } | null>;
  };
  readonly " $fragmentSpreads": FragmentRefs<"StorecastHeaderTV_storecast">;
  readonly " $fragmentType": "Storecast_storecastScreen";
};
export type Storecast_storecastScreen$key = {
  readonly " $data"?: Storecast_storecastScreen$data;
  readonly " $fragmentSpreads": FragmentRefs<"Storecast_storecastScreen">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "dashboardId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "Storecast_storecastScreen",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorecastHeaderTV_storecast"
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "dashboardId",
            "variableName": "dashboardId"
          }
        ],
        "concreteType": "Dashboard",
        "kind": "LinkedField",
        "name": "dashboard",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "widgets",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useWidgetToPos_widget"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AllWidgets_widget"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      "action": "THROW"
    }
  ],
  "type": "StorecastScreen",
  "abstractKey": null
};
})();

(node as any).hash = "9cccd7944daf4839f170bf1b5317a38f";

export default node;
